import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import { BrandLoader } from "@/components/brand/Logo";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AuthCallback from "@/pages/auth/AuthCallback";
import CommandCentre from "@/pages/CommandCentre";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Content from "@/pages/Content";
import CalendarPage from "@/pages/CalendarPage";
import Approvals from "@/pages/Approvals";
import Channels from "@/pages/Channels";
import ChannelSetup from "@/pages/ChannelSetup";
import Analytics from "@/pages/Analytics";
import BrandBrain from "@/pages/BrandBrain";
import Assets from "@/pages/Assets";
import Activity from "@/pages/Activity";
import Settings from "@/pages/Settings";
import Briefings from "@/pages/Briefings";
import Account from "@/pages/Account";
import Invite from "@/pages/Invite";
import { nextFrom } from "@/lib/api";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <BrandLoader label="Verifying session" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <WorkspaceProvider><AppShell>{children}</AppShell></WorkspaceProvider>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <BrandLoader label="Loading" />;
  if (user) return <Navigate to={nextFrom(location.search) || "/command-centre"} replace />;
  return children;
}

const APP_ROUTES = [
  ["/command-centre", CommandCentre], ["/campaigns", Campaigns], ["/campaigns/:id", CampaignDetail], ["/content", Content],
  ["/calendar", CalendarPage], ["/approvals", Approvals], ["/channels", Channels], ["/channels/setup", ChannelSetup], ["/analytics", Analytics],
  ["/brand-brain", BrandBrain], ["/assets", Assets], ["/activity", Activity], ["/settings", Settings], ["/briefings", Briefings], ["/account", Account],
];

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
      <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/invite" element={<Invite />} />
      {APP_ROUTES.map(([p, C]) => <Route key={p} path={p} element={<Protected><C /></Protected>} />)}
      <Route path="*" element={<Navigate to="/command-centre" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" offset={76} toastOptions={{ style: { background: "#0E1733", border: "1px solid #243153", color: "#F7FAFF" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
